import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// Components
import Form from "~/common/components/Form";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import { INVEST_LEVEL } from "~/constant/ApplyFormConstant";
export const DownArrowIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 8 5"
			width="8"
			height="5"
			className="ico_select-arrow"
		>
			<path
				d="M7.7,0.4C7.3,0,6.8,0,6.5,0.4L4,2.8L1.5,0.4C1.2,0,0.7,0,0.3,0.4S0,1.2,0.3,1.6l3.1,3.1C3.7,5,4.3,5,4.6,4.6
	l3.1-3.1C8,1.2,8,0.7,7.7,0.4z"
			/>
		</svg>
	);
};

const ApplyItemSetting = ({
	saveSetting,
	selected,
	setSelected,
	itemSettingModal,
	setItemSettingModal,
	itemSettingForm,
	applyDetail,
	settingList,
	setRoundItemModal,
	autoSelectNewOption
}) => {
	const [selectToggle, setSelectToggle] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		if (autoSelectNewOption && settingList.length > 0 && settingList[settingList.length - 1]?.title !== selected?.title) {
			setSelected(settingList[settingList.length - 1]);
		}
	}, [settingList, autoSelectNewOption, setSelected, selected]);


	return (
		<ModalTemplate
			modalState={itemSettingModal}
			setModalToggle={setItemSettingModal}
			title={t("pages.apply.ApplyManage.Modal.ApplyItemSetting.applyItemSetting")}
			width={700}
			className="item-setting-modal"
		>
			<div className="modal-content">
				{/* <div className="rating-setting-top">Apply 심사항목 선택</div> */}
				<Form useForm={itemSettingForm} className="judge-assign-form vertical">
					<div class="f__group">
						<label class="f__label">
							{t("pages.apply.ApplyManage.Modal.ApplyItemSetting.applyItemSelect")}
						</label>
						<div
							className={`c__select f__item ${selectToggle ? "open" : ""}`}
							onKeyDown={(e) => e.key === "Tab" && setSelectToggle(false)}
							onBlur={() => {
								setSelectToggle(false);
							}}
						>
							<p
								className={`c__selection-item`}
								onMouseDown={() => {
									setSelectToggle(!selectToggle);
								}}
							>
								{selected
									? selected.title
									: t(
										"pages.apply.ApplyManage.Modal.ApplyItemSetting.applyItemSettingSelect"
									)}
								<DownArrowIcon />
							</p>
							<ul className="c__select-dropdown">
								{settingList?.map((item) => {
									return (
										<li
											className={`c__select-dropdown-item ${item?.title === selected.title && "selected"
												}`}
											onClick={() => {
												setSelected(item);
												setSelectToggle(false);
											}}
										>
											{item?.title}
										</li>
									);
								})}
							</ul>
						</div>
					</div>
				</Form>
				<p className="setting-notice">
					{t("pages.apply.ApplyManage.Modal.ApplyItemSetting.newMessage")}
					<br />

					<button className="btn-link" onClick={() => setRoundItemModal(true)}>
						{t("pages.apply.ApplyManage.Modal.ApplyItemSetting.newApplyItem")}
					</button>

				</p>
				<div className="rating-setting-bottom">
					<dl className="company-info">
						<dt className="company-name">{applyDetail?.startup?.name}</dt>
						<dd className="company-desc"></dd>
					</dl>
					<dl className="company-data">
						<div>
							<dt>
								{t("pages.apply.ApplyManage.Modal.ApplyItemSetting.investStep")}
							</dt>
							<dd>
								{INVEST_LEVEL.find(
									(value) => value.value === applyDetail?.startup?.investLevel
								)?.label ?? "-"}
							</dd>
						</div>
						<div className="company-industry">
							<dt>{t("pages.apply.ApplyManage.Modal.ApplyItemSetting.industry")}</dt>
							<dd>{applyDetail?.startup?.industryField}</dd>
						</div>
					</dl>
				</div>
			</div>
			<div className="modal-footer">
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={() => saveSetting()}
				>
					{t("pages.apply.ApplyManage.Modal.ApplyItemSetting.confirm")}
				</button>
			</div>
		</ModalTemplate>
	);
};

export default ApplyItemSetting;
